import React from "react";
import { Link } from "react-router-dom";
import {
  Heart,
  Home as HomeIcon,
  Gavel,
  Building2,
  ShoppingCart,
  Briefcase,
  Percent,
  LayoutGrid,
  ArrowRight,
} from "lucide-react";

const topics = [
  {
    title: "Family",
    sub: "Divorce, custody",
    spec: "Family Law",
    icon: Heart,
    color: "#F472B6",
  },
  {
    title: "Property",
    sub: "Rent, disputes",
    spec: "Property Law",
    icon: HomeIcon,
    color: "#60A5FA",
  },
  {
    title: "Criminal",
    sub: "FIR, bail",
    spec: "Criminal Law",
    icon: Gavel,
    color: "#F59E0B",
  },
  {
    title: "Corporate",
    sub: "Business, MSME",
    spec: "Corporate Law",
    icon: Building2,
    color: "#10B981",
  },
  {
    title: "Consumer",
    sub: "Complaints, refund",
    spec: "Consumer Rights",
    icon: ShoppingCart,
    color: "#8B5CF6",
  },
  {
    title: "Employment",
    sub: "Job, salary, notice",
    spec: "Labour Law",
    icon: Briefcase,
    color: "#EC4899",
  },
  {
    title: "Tax & GST",
    sub: "ITR, GST notices",
    spec: "Tax Law",
    icon: Percent,
    color: "#F97316",
  },
  {
    title: "Other",
    sub: "More topics",
    spec: "Other",
    icon: LayoutGrid,
    color: "#64748B",
  },
];

export function TopicCards() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-10 pb-14 lg:pb-20">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2
            className="text-2xl lg:text-3xl font-extrabold text-[#0A2540]"
            style={{ fontFamily: "Poppins" }}
          >
            Browse by Legal Topic
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Find the right lawyer for your specific legal need
          </p>
        </div>
        <Link
          to="/lawyers"
          className="hidden md:inline-flex text-sm font-bold text-[#1E3A8A] hover:text-[#0A2540] items-center gap-1"
        >
          View all topics <ArrowRight size={14} />
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {topics.map((t) => (
          <Link
            key={t.title}
            to={`/lawyers?spec=${encodeURIComponent(t.spec)}`}
            data-testid={`topic-${t.title.toLowerCase().replace(/\s+/g, "-")}`}
            className="group bg-white border border-slate-200 rounded-2xl p-4 hover:shadow-lg hover:-translate-y-0.5 transition-all text-center"
          >
            <div
              className="h-11 w-11 rounded-xl grid place-items-center mx-auto"
              style={{ background: `${t.color}20`, color: t.color }}
            >
              <t.icon size={22} />
            </div>
            <h3
              className="mt-3 text-sm font-extrabold text-[#0A2540]"
              style={{ fontFamily: "Poppins" }}
            >
              {t.title}
            </h3>
            <p className="text-[11px] text-slate-500 mt-0.5 truncate">{t.sub}</p>
          </Link>
        ))}
      </div>

      <div className="mt-4 md:hidden text-right">
        <Link
          to="/lawyers"
          className="inline-flex text-sm font-bold text-[#1E3A8A] hover:text-[#0A2540] items-center gap-1"
        >
          View all topics <ArrowRight size={14} />
        </Link>
      </div>
    </section>
  );
}

export default TopicCards;
